<template>
  <el-form ref="ff" v-loading="loading" :model="formdata">
    <el-form-item label="与经销商结算金额">
      <el-input v-model="amount" readonly>
        <template slot="prefix">￥</template>
      </el-input>
    </el-form-item>
    <el-form-item label="经销商打款账户" prop="Bankcard" required>
      <el-input v-model="formdata.Bankcard" />
    </el-form-item>
    <el-form-item label="结算方式" prop="POClear" required>
      <metaPicker type="POClear" :value.sync="formdata.POClear" />
    </el-form-item>
    <el-form-item label="打款备注">
      <el-input type="textarea" :rows="5" v-model="formdata.Message" />
    </el-form-item>
    <el-form-item>
      <uploader ref="uploadRef" :data="{ ObjectId: formdata.Id, Mode: 'payment-screenshot' }" multiple :auto-upload="false" accept=".jpg,.png">
        <el-link slot="trigger" icon="el-icon-upload" size="small" type="primary">上传付款截图</el-link>
      </uploader>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit(true)">确定</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  components: {
    metaPicker: () => import("@/views/system/meta/item/_picker.vue"),
    uploader: () => import("@/views/system/file/multipleUpload.vue"),
  },
  props: {
    id: { type: String },
    bankcard: { type: String },
    poclear: { type: String },
    amount: { type: Number },
    callback: { type: Function },
    layerid: { type: String, default: null }
  },
  data () {
    return {
      loading: false,
      formdata: {
        Id: this.id,
        Bankcard: this.bankcard,
        POClear: this.poclear,
      }
    }
  },
  created () {
    this.loadApplys()
  },
  methods: {
    onSubmit () {
      this.$refs['ff'].validate(valid => {
        if (valid && !this.loading) {
          this.loading = true
          this.$apis.mall.torder.complete(this.formdata).then(() => {
            return this.$refs.uploadRef.onSubmit()
          }).then(() => {
            this.callback()
            this.$layer.close(this.layerid)
          }).catch(e => {
            this.$message.error(e || "执行错误")
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style>
</style>